jQuery(function ($) {
  $(".button-addtocalendar-modal").on("click", function (e) {
    e.preventDefault();

    $("#overlay-mask").fadeIn();
    $("#addtocalendar-modal").delay(500).fadeIn();
  });

  const addToCalendarBtn = $(".button-addtocalendar");
  addToCalendarBtn.each(function () {
    const trigger = $(this);

    trigger.on("click", function () {
      const service = trigger.data("type");
      const data = trigger.parents("#addtocalendar-container").data("json");

      // REFER TO THIS FOR CALENDAR LINK GENERATION: https://parcel.io/tools/calendar
      if (service === "google") {
        addToGoogleCalendar(data);
      } else if (service === "outlook") {
        addToOutlookCalendar(data);
      } else if (service === "ical") {
        addToiCalendar(data);
      }
    });
  });

  function addToGoogleCalendar(data) {
    const { title, location, startDatetime, endDatetime } = data;

    let calendarUrl =
      "https://calendar.google.com/calendar/render?action=TEMPLATE";

    let dateString =
      startDatetime && endDatetime
        ? `${startDatetime["google"]}/${endDatetime["google"]}`
        : startDatetime["google"];
    calendarUrl += `&dates=${encodeURIComponent(dateString)}`;

    if (title) {
      calendarUrl += `&text=${encodeURIComponent(title)}`;
    }

    if (location) {
      calendarUrl += `&details=${encodeURIComponent(location)}`;
    }

    window.open(calendarUrl);
  }

  function addToOutlookCalendar(data) {
    const { title, location, startDatetime, endDatetime } = data;

    let calendarUrl =
      "https://outlook.live.com/calendar/0/action/compose?rru=addevent";
    if (startDatetime) {
      calendarUrl += "&startdt=" + encodeURIComponent(startDatetime["outlook"]);
    }
    if (endDatetime) {
      calendarUrl += "&enddt=" + encodeURIComponent(endDatetime["outlook"]);
    }
    if (title) {
      calendarUrl += "&subject=" + encodeURIComponent(title);
    }
    if (location) {
      calendarUrl += "&body=" + encodeURIComponent(location);
    }
    window.open(calendarUrl);
  }

  function addToiCalendar(data) {
    const { title, location, startDatetime, endDatetime } = data;

    let iCalUrl = `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT`;

    if (startDatetime) {
      iCalUrl += `\nDTSTART:${startDatetime["ical"]}`;
    }
    if (endDatetime) {
      iCalUrl += `\nDTEND:${endDatetime["ical"]}`;
    }
    if (title) {
      iCalUrl += `\nSUMMARY:${title}`;
    }
    if (location) {
      iCalUrl += `\nDESCRIPTION:${location}`;
    }
    iCalUrl += `\nEND:VEVENT\nEND:VCALENDAR`;

    iCalUrl = `data:text/calendar;charset=utf-8,${encodeURIComponent(iCalUrl)}`;

    let downloadLink = document.createElement("a");
    downloadLink.href = iCalUrl;
    downloadLink.download = "event.ics";
    downloadLink.click();
  }
});
